
import React from 'react';
import DashboardLayout from '@/components/DashboardLayout';
import NewsletterSection from '@/components/newsletter/NewsletterSection';

const News = () => {
  return (
    <DashboardLayout>
      <div className="container max-w-4xl mx-auto py-12 px-4">
        <NewsletterSection />
      </div>
    </DashboardLayout>
  );
};

export default News;
